module.exports = __webpack_public_path__ + "static/03-1-17405e00657a8dbc65680783bb1b7310.jpg";